import React from "react";
import "./IntroductionSection.scss";

const IntroductionSection = () => {
  return (
    <section className="introduction-section">
      <div className="introduction-section__left-column">
        <p className="introduction-section__about-label">About</p>

        <h2 className="introduction-section__heading">
          We love to make great things, things that matter.
        </h2>
      </div>

      <div className="introduction-section__right-column">
        <p className="introduction-section__description">
          Funding handshake buyer business-to-business metrics iPad partnership.
          First mover advantage innovator success deployment non-disclosure.
        </p>
      </div>
    </section>
  );
};

export default IntroductionSection;
